'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.unsubscribe = exports.publishSticky = exports.subscribe = exports.publish = undefined;

var _types = require('./types');

Object.keys(_types).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _types[key];
        }
    });
});

var _messageBus = require('./messageBus');

var defaultBus = _interopRequireWildcard(_messageBus);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

// Exported functions
var _ref = function messageBus(root) {
    return root.WH && root.WH.messageBus ? root.WH.messageBus : defaultBus;
}(typeof window !== 'undefined' ? window : global),
    publish = _ref.publish,
    subscribe = _ref.subscribe,
    publishSticky = _ref.publishSticky,
    unsubscribe = _ref.unsubscribe;
/* global window: true */


exports.publish = publish;
exports.subscribe = subscribe;
exports.publishSticky = publishSticky;
exports.unsubscribe = unsubscribe;
//# sourceMappingURL=index.js.map